import React from 'react';
import cn from 'classnames';
import { CASFields, getStudentCASValue } from './utils';

const Timer = ({ parentAssignment, customSetting }) => {
  const { value: timer, isCustomSetting } = getStudentCASValue({
    field: CASFields.Timer,
    parentAssignment,
    customSetting,
  });

  return (
    <div className={cn({ 'font-bold': isCustomSetting })}>
      {timer ? `${timer} min` : '-'}
      {isCustomSetting && (
        <span className="mx-1">
          * <span className="sr-only">has exception</span>
        </span>
      )}
    </div>
  );
};

export default Timer;
